// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wBRP","title":"styles_title__1csPe"};